import { defineCustomElement } from '~/utility/define-custom-element';

import { LitEntity, css, html } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';

class DeviceSearchResults extends LitEntity {
  static get styles() {
    return [
      sharedStyles,
      css`
        :host {
          display: block;
        }
        bn-card {
          padding-top: 0.75rem;
          max-width: 800px;
        }
        p {
          background-color: var(--white-base);
          margin-left: 0.5rem;
          margin-top: 0;
        }
      `,
    ];
  }

  render() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }
    if (!this.entity || !this.entity.properties.deviceId) {
      return html`<p>
        ${this.t('legacyLit.deviceSearchResults.prompt')}
      </p>`;
    }
    return html`
      <bn-card
        .href="${`/devices/show?deviceId=${encodeURIComponent(this.href)}`}"
        @click="${() => this.dispatchEvent(new CustomEvent('select'))}"
      >
        <h3>${this.t('legacyLit.deviceSearchResults.foundDevice')}</h3>
        <device-details .href="${this.href}"></device-details>
      </bn-card>
    `;
  }
}

defineCustomElement('device-search-results', DeviceSearchResults);
